import { LeadSource } from '@shared/types/lead-source';

export interface LeadSourceObject {
  title: string;
  reference: LeadSource;
}

export const leadSources: LeadSourceObject[] = [
  { title: 'Hunting', reference: 'hunting' },
  { title: 'Marketing Campaign', reference: 'marketing_campaign' },
  { title: 'Marketing Event', reference: 'marketing_event' },
  { title: 'Reseller', reference: 'reseller' },
  { title: 'Website', reference: 'website' },
];
